import { createRequestHelper } from '@utils/swr'
import { type TokenLoginRequest } from '../types/apiRequest'
import { type TokenLoginResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['post']['tokenLogin'], TokenLoginResponse, TokenLoginRequest>({
  client: 'fortune',
  key: params => `/campaigns/${params?.campaign_code}/member/token_login`,
  fetcher: client => (_, params) => {
    return client.post(`/campaigns/${params?.campaign_code}/member/token_login`, {
      cosign_token: params?.cosign_token,
      campaign_code: params?.campaign_code,
    })
  },
  isImmutable: true,
})

export const useApiTokenLogin = useRequest
